import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

function loadClarityIfEnabled(): void {
  if (!environment.ENABLE_CLARITY || !environment.CLARITY_ID) {
    return;
  }
  (function (c: any, l: Document, a: string, r: string, i: string) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    const t = l.createElement(r) as HTMLScriptElement;
    t.async = true;
    t.src = 'https://www.clarity.ms/tag/' + i;
    const y = l.getElementsByTagName(r)[0];
    y.parentNode?.insertBefore(t, y);
  })(window as any, document, 'clarity', 'script', environment.CLARITY_ID);
}

loadClarityIfEnabled();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
